<div class="container">
  <div class="header">
    <p>{{ translation?.title }}</p>
  </div>
  <div class="body">
    <abc-text-box
      #textBox
      label="{{ translation?.nameOfRootElement }}"
      [value]="rootElementName"
      (onValueChanged)="onRootElementNameChange($event)"
      [valueChangeEvent]="'input'"
      style="margin-bottom: 20px"
    ></abc-text-box>
    <abc-drop-down-box
      label="{{ translation?.topic }}"
      [dataSource]="objectSpaceInfos"
      [displayExpr]="'name'"
      [valueExpr]="'value'"
      [gridColumns]="gridColumns"
      [value]="objectSpaceName"
      (onValueChanged)="onObjectSpaceNameChange($event)"
      (onOpened)="onOpenSpecialFields()"
    ></abc-drop-down-box>
  </div>
</div>
